var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.file.fileName,
        visible: true,
        "append-to-body": "",
        width: "88%",
        top: "4vh",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "drive-preview",
        },
        [
          _vm.error
            ? _c("el-alert", {
                attrs: { title: _vm.error, type: "warning", closable: false },
              })
            : _vm._e(),
          _vm.url && _vm.file.fileKind === "IMAGE"
            ? _c("img", { attrs: { src: _vm.url } })
            : _vm.url && _vm.file.fileKind === "VIDEO"
            ? _c("video", { attrs: { src: _vm.url, controls: "" } })
            : _vm.url && _vm.file.fileKind === "VOICE"
            ? _c("audio", { attrs: { src: _vm.url, controls: "" } })
            : _vm.legacyHTML
            ? _c("iframe", {
                attrs: {
                  srcdoc: _vm.legacyHTML,
                  sandbox: "",
                  title: "旧版Office预览",
                },
              })
            : _vm.html
            ? _c("iframe", {
                ref: "frame",
                attrs: {
                  srcdoc: _vm.html,
                  sandbox: "allow-scripts",
                  referrerpolicy: "no-referrer",
                  title: "文档只读预览",
                },
              })
            : _vm.text !== null
            ? _c("pre", { staticClass: "text-preview" }, [
                _vm._v(_vm._s(_vm.text)),
              ])
            : !_vm.loading && !_vm.error
            ? _c("p", [_vm._v("当前格式可下载原文件后查看。")])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.download } },
            [_vm._v("下载原文件")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }